import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Modal, Row, Badge } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import FalconCloseButton from 'components/common/FalconCloseButton';
import IconButton from 'components/common/IconButton';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';

const ModalNuevoNIT = ({ show, onHide, onSuccess }) => {
    const { token, setToken } = useToken();
    const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
        defaultValues: {
            bIsActive: true
        }
    });
    const { showErrorToast } = useToast();
    const [estatus, setEstatus] = useState(true);
    const [guardando, setGuardando] = useState(false);

    //Obtener UUID para usuario o contrase�a
    const ObtenerCadenaRandom = async (action) => {
        const response = await fetch("/api/licencia/ObtenerCadenaRandom", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'text/plain'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.text();
            console.log(data);

            if (action == 'Usuario')
                setValue("vUsuario", data);
            else if (action == 'vPassword')
                setValue("vPassword", data);
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    //Registrar NIT
    const GuardarNIT = async (values) => {
        setGuardando(true);
        console.log(values);
        const response = await fetch("/api/PlanesFacturacionBolivia/GuardarNIT/?jsonNIT=" + encodeURIComponent(JSON.stringify(values)), {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
            setGuardando(false);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {
                reset();
                setEstatus(true);
                onSuccess();
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setGuardando(false);
    };

    const onSubmit = data => {
        GuardarNIT(data);
    };

    const onCheckedChange = (e) => {
        console.log(e.target.checked);
        setEstatus(e.target.checked);
        setValue("bIsActive", e.target.checked);
    };

    const handleClose = () => {
        reset();
        setEstatus(true);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Modal.Header>
                    <Modal.Title>Registra nuevo NIT</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={handleClose} />
                </Modal.Header>
                <Modal.Body>
                    <p>Registra un nuevo NIT, de acuerdo a los lineamientos dictados por el Servicio de Impuestos Nacionales (SIN).</p>

                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>ESTATUS</Form.Label>
                                <Row>
                                    <Col md={2}>
                                        <Form.Check
                                            {...register("bIsActive")}
                                            type="switch"
                                            checked={estatus}
                                            onChange={onCheckedChange}
                                        />
                                    </Col>
                                    <Col md={10}>
                                        {estatus ? (
                                            <Col>
                                                <img src="/img/activo.png" alt="Activo" /> <Badge bg="success">Activo</Badge>
                                            </Col>
                                        ) : (
                                            <Col>
                                                <img src="/img/noactivo.png" alt="Desactivado" /> <Badge bg="danger">Desactivado</Badge>
                                            </Col>
                                        )}
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>NIT</Form.Label>
                                <Form.Control
                                    isInvalid={!!errors.vNIT}
                                    {...register("vNIT", {
                                        required: 'El NIT es requerido'
                                    })}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.vNIT && errors.vNIT.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Nombre del contribuyente</Form.Label>
                                <Form.Control
                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase(); }}
                                    isInvalid={!!errors.vNombre}
                                    {...register("vNombre", {
                                        required: 'El Nombre es requerido',
                                        maxLength: 200,
                                        minLength: 1
                                    })}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.vNombre && errors.vNombre.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Usuario{' '}
                                    <IconButton
                                        className="ms-2"
                                        iconClassName="fs--2 me-1"
                                        variant="falcon-primary"
                                        size="sm"
                                        icon="circle"
                                        onClick={() => ObtenerCadenaRandom('Usuario')}
                                    >
                                        Generar
                                    </IconButton>
                                </Form.Label>
                                <Form.Control
                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase(); }}
                                    isInvalid={!!errors.vUsuario}
                                    {...register("vUsuario", {
                                        required: 'El usuario es requerido',
                                        maxLength: 40,
                                        minLength: 1
                                    })}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.vUsuario && errors.vUsuario.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Contrase&ntilde;a{' '}
                                    <IconButton
                                        className="ms-2"
                                        iconClassName="fs--2 me-1"
                                        variant="falcon-primary"
                                        size="sm"
                                        icon="circle"
                                        onClick={() => ObtenerCadenaRandom('vPassword')}
                                    >
                                        Generar
                                    </IconButton>
                                </Form.Label>
                                <Form.Control
                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase(); }}
                                    isInvalid={!!errors.vPassword}
                                    {...register("vPassword", {
                                        required: 'La contrase\u00F1a es requerido',
                                        maxLength: 40,
                                        minLength: 1
                                    })}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.vPassword && errors.vPassword.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose} variant='primary' disabled={guardando}>Cerrar</Button>
                    <Button type="submit" variant='success' disabled={guardando}>
                        {guardando ? 'Guardando...' : 'Registrar'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

ModalNuevoNIT.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
};

export default ModalNuevoNIT;
